import React from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";

interface ColorPlanoProp {
  boxes?: number | any;
  item_image?: string;
  variant_title?: string;
  price?: string | any;
  temp_cart_id?: number | any;
  cart_id: number | any;
  power_type?: string;
  compare_at_price?: string | any;
}

export const ColorPlano = (props: ColorPlanoProp) => {
  const { updateCartItem } = useShoppingCart();

  // let quantity = 0;

  // if (props.boxes === undefined || props.left_boxes === null) {
  //     quantity = props.right_boxes;
  // } else if (props.right_boxes === undefined || props.right_boxes === null) {
  //     quantity = props.left_boxes;
  // } else {
  //     quantity = props.left_boxes + props.right_boxes;
  // }

  const increaseQuantityLeft = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: parseInt(props.boxes) + 1,
    prescription: {
      powerType: "CONTACT_LENS",
      left: {
        boxes: parseInt(props.boxes) + 1,
        sph: "0.00",
      },
    },
  };

  const decreaseQuantityLeft = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: parseInt(props.boxes) - 1,
    prescription: {
      powerType: "CONTACT_LENS",
      left: {
        boxes: parseInt(props.boxes) - 1,
        sph: "0.00",
      },
    },
  };




  return (
    <>
      {/* <div className="productImage">
                <img src={props.item_image} alt="" />
            </div> */}
      {/* <p>{props.variant_title}</p> */}
      <div className="colorPrice quantityPrice ">
        <div className="eyeSpecs">
          <span className="eyeHeading quantity_heading">Quantity</span>
          <span className="quantityCount">
            <button
              onClick={
                parseInt(props.boxes) > 1
                  ? () => updateCartItem(decreaseQuantityLeft)
                  : undefined
              }
            >
              -
            </button>
            {parseInt(props.boxes)}
            <button onClick={() => updateCartItem(increaseQuantityLeft)}>
              +
            </button>
          </span>
        </div>
        <div className="itemPrice">
          {/* <span className="itemPriceCompare">Rs. 300 </span> */}
          <span className="itemPriceCompare">
            Rs. {props.compare_at_price * parseInt(props.boxes)}{" "}
          </span>
          <span className="itemPriceSelling">
            Rs. {parseInt(props.price) * parseInt(props.boxes)}
          </span>
        </div>
      </div>
    </>
  );
};
